import { render, staticRenderFns } from "./indexTwo.vue?vue&type=template&id=f927f728&scoped=true&"
import script from "./indexTwo.vue?vue&type=script&lang=ts&"
export * from "./indexTwo.vue?vue&type=script&lang=ts&"
import style0 from "./indexTwo.vue?vue&type=style&index=0&id=f927f728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f927f728",
  null
  
)

export default component.exports